import { type TBreakpoint } from '~/types/components/breakpoint-types'

export const breakpoints: TBreakpoint[] = [
  { name: 'xs', min: 0, max: 575 },
  { name: 'sm', min: 576, max: 767 },
  { name: 'md', min: 768, max: 991 },
  { name: 'lg', min: 992, max: 1199 },
  { name: 'xl', min: 1200, max: 1399 },
  { name: 'xxl', min: 1400, max: 1024 * 8 }
]
